// consoleLog.js helper to log messages to the console on non-production environments
export default function consoleLog(...messages) {
  if (import.meta.env.VITE_ENVIRONMENT !== 'PRODUCTION') {
    console.log(...messages);
  }
}
